const luisValePedro = {
  image: 'https://media.lahaus.com/statics/static/images/hero-carousel/LuisValePedro.png?width=372&height=462&fit=cover',
  animated_image: 'https://media.lahaus.com/statics/static/images/hero-carousel/LuisValePedro.gif?width=372&height=462&fit=cover',
  name: 'Luis, Vale y Pedro',
  beds: 3,
  baths: 2,
  id: 'investor-1'
}

const luzYDiego = {
  image: 'https://media.lahaus.com/statics/static/images/hero-carousel/Luz&Diego.png?width=372&height=462&fit=cover',
  animated_image: 'https://media.lahaus.com/statics/static/images/hero-carousel/Luz&Diego.gif?width=372&height=462&fit=cover',
  name: 'Luz y Diego',
  beds: 2,
  baths: 2,
  id: 'investor-3'
}

const edgar = {
  image: 'https://media.lahaus.com/statics/static/images/hero-carousel/Edgar.png?width=372&height=462&fit=cover',
  animated_image: 'https://media.lahaus.com/statics/static/images/hero-carousel/Edgar.gif?width=372&height=462&fit=cover',
  name: 'Edgar',
  beds: 2,
  baths: 2,
  id: 'investor-4'
}

const paolaYZeus = {
  image: 'https://media.lahaus.com/statics/static/images/hero-carousel/Paola&Zeus.png?width=372&height=462&fit=cover',
  animated_image: 'https://media.lahaus.com/statics/static/images/hero-carousel/Paola&Zeus.gif?width=372&height=462&fit=cover',
  name: 'Paola y Zeus',
  beds: 1,
  baths: 1,
  id: 'investor-2'
}

const juliana = {
  image: 'https://media.lahaus.com/statics/static/images/hero-carousel/Juliana.png?width=372&height=462&fit=cover',
  animated_image: 'https://media.lahaus.com/statics/static/images/hero-carousel/Juliana.gif?width=372&height=462&fit=cover',
  name: 'Juliana',
  beds: 2,
  baths: 2,
  id: 'investor-5'
}

const marta = {
  image: 'https://media.lahaus.com/statics/static/images/hero-carousel/Marta.png?width=372&height=462&fit=cover',
  animated_image: 'https://media.lahaus.com/statics/static/images/hero-carousel/Marta.gif?width=372&height=462&fit=cover',
  name: 'Marta',
  beds: 2,
  baths: 2,
  id: 'investor-6'
}

const camilaYMora = {
  image: 'https://media.lahaus.com/statics/static/images/hero-carousel/Camila&Mora.png?width=372&height=462&fit=cover',
  animated_image: 'https://media.lahaus.com/statics/static/images/hero-carousel/Camila&Mora.gif?width=372&height=462&fit=cover',
  name: 'Camila y Mora',
  beds: 1,
  baths: 2,
  id: 'investor-2'
}

const mariaFernanda = {
  image: 'https://media.lahaus.com/statics/static/images/hero-carousel/MariaFernanda.png?width=372&height=462&fit=cover',
  animated_image: 'https://media.lahaus.com/statics/static/images/hero-carousel/MariaFernanda.gif?width=372&height=462&fit=cover',
  name: 'Maria Fernanda',
  beds: 2,
  baths: 2,
  id: 'investor-5'
}

const patricia = {
  image: 'https://media.lahaus.com/statics/static/images/hero-carousel/Patricia.png?width=372&height=462&fit=cover',
  animated_image: 'https://media.lahaus.com/statics/static/images/hero-carousel/Patricia.gif?width=372&height=462&fit=cover',
  name: 'Patricia',
  beds: 2,
  baths: 2,
  id: 'investor-6'
}

export const INVESTORS_CAROUSEL = {
  co: [luisValePedro, paolaYZeus, luzYDiego, edgar, juliana, marta],
  mx: [luisValePedro, camilaYMora, luzYDiego, edgar, mariaFernanda, patricia]
}
